import PackageType from ".";

export const packageType = [
  {
    path: "/packageType",
    element: <PackageType />,
  },
];
